/* eslint-disable max-len */
/* eslint-disable eqeqeq */
/* eslint-disable curly */

import { Account } from "src/models/account";

/* eslint-disable no-underscore-dangle */
export class AccountHelper {
    private static _instance: AccountHelper;

    token: any;

    staff = false;
    staffAdmin = false;
    ngRodeoAdmin = false;

    incognito = false;

    private constructor() { }

    static instance(): AccountHelper {
        if (this._instance === undefined)
            this._instance = new this();

        return this._instance;
    }

    loadToken(token) {
        this.token = token;

        if (this.token != null && this.token.roles != null) {
            this.staff = this.token.roles.filter(x => x.roleId >= 2).length > 0;
            this.staffAdmin = this.token.roles.filter(x => x.roleId >= 4).length > 0;
            this.ngRodeoAdmin = this.token.roles.filter(x => x.roleId >= 6).length > 0;
        }
    }

    public isSetup(account: Account): boolean {
        if (!account.firstName || !account.lastName || !account.birthDate || !account.city || !account.state) {
            return false;
        }

        return true;
    }

    toggleMode() {
        this.incognito = !this.incognito;
    }

    clearToken() {
        this.token = undefined;
        this.staff = false;
        this.staffAdmin = false;
        this.ngRodeoAdmin = false;
    }

    isStaff(superman: boolean = false) {
        if (!superman && this.incognito)
            return false;

        return this.staff;
    }

    isStaffOfEvent(event) {
        if (this.incognito || this.token == undefined || this.token.roles == undefined)
            return false;

        if (this.ngRodeoAdmin)
            return true;

        return this.token.roles.filter(x => x.organizationId == event.organization.id && x.producerId == event.producer.id && x.roleId > 1).length > 0;
    }

    isStaffOfOrganization(organization) {
        if (this.incognito || this.token == undefined || this.token.roles == undefined)
            return false;

        if (this.ngRodeoAdmin)
            return true;

        return this.token.roles.filter(x => x.organizationId == organization.id && x.roleId > 1).length > 0;
    }

    isStaffAdmin() {
        if (this.incognito)
            return false;

        return this.staffAdmin;
    }

    isNextGenAdmin() {
        if (this.incognito)
            return false;

        return this.ngRodeoAdmin;
    }

    getId() {
        return this.token.id;
    }

    isStandard() {
        return this.token.membershipId == 1 || this.token.membershipId == 5;
    }

    isPlatinum() {
        return this.token.membershipId == 3 || this.token.membershipId == 6 || this.token.membershipId == 7;
    }

    isMember() {
        return this.token.membershipId !== undefined && this.token.membershipId;
    }

    isMembershipExpired() {
        return this.token.membershipExpired;
    }
}
